import type { FC } from 'react';
import { RegistrationMethod } from '@shared/types/common';
import { CommonButton } from '@shared/ui';
import { AuthForm } from '@src/modules/Authentication/AuthFrom';
import ButtonLink from '@src/modules/Authentication/ButtonLink/index.ts';
import { Captcha } from '@src/modules/Authentication/Captcha';
import CustomInput from '@src/modules/Authentication/CustomInput';
import * as st from './styles.module.scss';

interface Props {
  model: any;
  settings: any;
  type: string;
  setType: (type: RegistrationMethod) => void;
  windowWidth: number;
}

export const RepeatStepTwo: FC<Props> = ({ model, settings, type, setType, windowWidth }) => {
  const is_call_active = settings.is_call_active;
  const is_sms_active = settings.is_sms_active;

  return (
    <AuthForm
      onSubmit={model.handleSubmit((data: any) => model.checkedPhone(data.phonenumber, type))}
    >
      <div className={st.block__up}>
        <CustomInput
          tabindex={0}
          type="phonenumber"
          label="Проверьте правильность указанного номера телефона"
          name="phonenumber"
          control={model.controlPhoneNumber}
          error={model.phoneNumberErrors?.phonenumber}
          disabled={model.isLoading}
          variant="outline"
        />
      </div>
      <ButtonLink
        className={st.buttonLink}
        disabled={model.isLoading}
        handler={model.openEmailForm}
      >
        Восстановить через почту
      </ButtonLink>
      <Captcha className={st.captcha} onChange={model.onCaptchaChange} />
      <section className={st.buttons}>
        {is_sms_active && (
          <CommonButton
            tabIndex={0}
            type="submit"
            disabled={!model.isCaptchaVerified}
            onClick={() => setType('SMS')}
          >
            Отправить СМС
          </CommonButton>
        )}

        {is_call_active && (
          <CommonButton
            tabIndex={0}
            type="submit"
            variant="secondary"
            disabled={!model.isCaptchaVerified}
            onClick={() => setType('CALL')}
          >
            Повторить звонок
          </CommonButton>
        )}
      </section>
    </AuthForm>
  );
};
